import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { isValidArray, isValidObject } from "../../Services/validators";
import {
  // getSelectedComplaintsDetailsData,
  getSelectedComplaintsLatestUpdatesData
} from "../../Utils/Constants/Complaints";
import { Fields, getAppsUrls } from "../../Utils/Constants/Constants";
import Button from "../Button/Button";
import { ShareCard } from "../Cards/Cards";
import CarouselAndAudioPlayer from "../CarouselAndAudioPlayer/CarouselAndAudioPlayer";
import CropperModal from "../CropperModal/CropperModal";
import Modal from "../Modal/Modal";
import PreviewBar from "../PreviewBar/PreviewBar";
import TrackProgress from "../TrackProgress/TrackProgress";
import InputBox from "../InputBox/InputBox";

export default function ComplaintsPreview(props) {
  const [file, setFile] = useState({ image: [], audio: null });
  const [croppedImage, setCroppedImage] = useState({ images: [] });
  const [remarks, setRemarks] = useState("");
  const [showShareModal, setShowShareModal] = useState(false);
  const { complaintId } = useParams();

  const handleCloseComplaintDisable = useMemo(() => {
    return isValidArray(croppedImage.images) ||
      file.audio !== null ||
      remarks.length > 0
      ? false
      : true;
  }, [croppedImage.images, file.audio, remarks]);

  useEffect(() => {
    if (complaintId) {
      props.setSelectedComplaint(complaintId, props.navigate);
    }
    return () => {
      props.setSelectedComplaint(null);
    };
    // eslint-disable-next-line
  }, [complaintId]);

  return (
    <>
      <PreviewBar
        onCloseClick={() => {
          props.navigate("/locations/complaints");
        }}
        title={
          <div className="display-flex flex-align-items-center">
            <div className="font-color-tertiaryColor font-size-larger">
              {props.data?.documentId}
            </div>
            <div
              style={{
                color: "var(--secondaryColor)"
              }}
              className="padding-left-default font-size-small text-uppercase"
            >
              {props.data?.status?.currentStatus}
            </div>
          </div>
        }
        description={`${props.data?.location?.PCTNo?.padStart(2, "0")} - ${
          props.data?.location?.address
        }`}
        onShareClick={() => {
          if (isValidObject(props.data)) {
            setShowShareModal(true);
          }
        }}
        loading={props.loading || !isValidObject(props.data)}
      >
        <div style={{ opacity: showShareModal ? "40%" : "100%" }}>
          {/* <TrackProgress
            title="Details"
            isLast={false}
            state="INACTIVE"
            data={
              <div className="inherit-parent-width">
                <ComplaintDetails data={props.data} />
              </div>
            }
          /> */}

          {props.data?.turnaround ? (
            <TrackProgress
              title={"Details"}
              state={"INACTIVE"}
              isLast={false}
              data={
                <div className="inherit-parent-width">
                  <ComplaintLatestUpdates
                    data={{ turnaround: props.data?.turnaround }}
                    complaintsLoading={props.complaintsLoading}
                  />
                </div>
              }
            />
          ) : (
            <></>
          )}

          {props.data?.latestUpdate?.map((data, i) => (
            <div key={i}>
              <TrackProgress
                title={data.description}
                state={
                  props.data?.takenOverBy?.employeeId ? "INACTIVE" : "ACTIVE"
                }
                isLast={
                  props.data?.latestUpdate.length - 1 === i &&
                  (props.data?.status?.currentStatus === "CLOSED" ||
                    props.data?.status?.currentStatus === "PENDING CLOSURE")
                    ? true
                    : false
                }
                data={
                  <div className="inherit-parent-width">
                    <ComplaintLatestUpdates
                      data={data}
                      complaintsLoading={props.complaintsLoading}
                    />

                    {props.data?.latestUpdate.length - 1 !== i && (
                      <div
                        style={{
                          height: "2px",
                          backgroundColor: "grey",
                          width: "100%"
                        }}
                      />
                    )}
                  </div>
                }
              />
            </div>
          ))}

          {props.data?.status?.currentStatus !== "CLOSED" &&
          props.data?.status?.currentStatus !== "PENDING CLOSURE" ? (
            <TrackProgress
              title="Manage"
              isLast={true}
              state={
                props.data?.takenOverBy?.employeeId ||
                props.data?.status?.currentStatus === "UNDER REVIEW"
                  ? "ACTIVE"
                  : "PROGRESS"
              }
              data={
                <div className="inherit-parent-width">
                  <ComplaintManage
                    complaintsLoading={props.complaintsLoading}
                    closeComplaintClick={() => {
                      props.closeComplaintClick({
                        remarks: remarks,
                        image: croppedImage.images,
                        audio: file.audio
                      });
                    }}
                    profile={props.profile}
                    closeComplaintDisable={handleCloseComplaintDisable}
                    loading={props.loading}
                    croppedImage={croppedImage}
                    remarks={remarks}
                    setRemarks={setRemarks}
                    data={props.data}
                    file={file}
                    setCroppedImage={setCroppedImage}
                    setFile={setFile}
                    takeOverOnClick={props.takeOverOnClick}
                    verifyCompliantClick={(type) => {
                      props.verifyCompliantClick(type);
                    }}
                  />
                </div>
              }
            />
          ) : (
            <></>
          )}
        </div>

        <Modal
          show={showShareModal && isValidObject(props.data)}
          canIgnore={true}
          onClose={() => setShowShareModal(false)}
          width="inherit-parent-width"
          maxWidth="none"
          minWidth="none"
          height="none"
          background="background-color-tertiaryColor2"
          position="position-absolute bottom-0 right-0 left-0"
          borderRadius="false"
          transparentBackgroundColor={true}
        >
          <div
            className="font-color-tertiaryColor margin-larger"
            style={{ width: "calc(100% - 48px)" }}
            data-cy="SHARE-MODAL"
          >
            <div className="flex-justify-content-center flex-direction-column flex-align-items-center ">
              <div className="font-size-large margin-bottom-small padding-bottom-smaller">
                Share Complaint
              </div>
              <div className="font-color-tertiaryColor6 font-size-medium margin-bottom-larger">
                Can access the complaint through connected apps
              </div>
            </div>
            <div
              className="display-flex flex-direction-column"
              style={{ gap: "24px" }}
            >
              {getAppsUrls.map((data) => {
                const isPublic = data.key === "public";
                const isEmployee = data.key === "employees";
                const isSupport = data.key === "support";
                if (isPublic) {
                  return null;
                }
                if (
                  ["CLOSED", "UNDER REVIEW"].includes(
                    props.data?.status?.currentStatus
                  ) &&
                  (isEmployee || isSupport)
                ) {
                  return null;
                }
                if (
                  props.data?.status?.currentStatus === "PENDING CLOSURE" &&
                  isEmployee
                ) {
                  return null;
                }
                return (
                  <ShareCard
                    key={data.key}
                    data={data}
                    complaintId={props.data?.documentId}
                  />
                );
              })}
            </div>
          </div>
        </Modal>
      </PreviewBar>
      <Modal
        show={isValidArray(file?.image)}
        canIgnore={true}
        onClose={() => {
          setFile({ ...file, image: [] });
        }}
        width="width-60-percentage"
        maxWidth="max-width-800px"
        maxHeight="max-height-80-percentage"
        background="false"
        boxShadow="false"
        borderRadius="false"
        height="height-80-percentage"
      >
        <div
          data-cy="cropper-modal"
          className={`font-family-gilroy-regular font-color-tertiaryColor6 background-color-tertiaryColor1`}
        >
          <CropperModal
            className="border-radius-default"
            OnBlobCreate={(blob) => {
              const imageFile = new File([blob], `${+new Date()}.png`, {
                type: "image/png"
              });
              setCroppedImage({ images: [...croppedImage.images, imageFile] });
            }}
            file={file.image}
            setFile={() => {
              setFile({ ...file, image: [] });
            }}
          />
        </div>
      </Modal>
    </>
  );
}

const ComplaintLatestUpdates = (props) => {
  return (
    <div className="inherit-parent-width">
      {getSelectedComplaintsLatestUpdatesData(props.data)?.map(
        (data, i) =>
          isValidArray(data) && (
            <div key={i}>
              <Fields title={data?.[0]} data={data?.[1]} />
            </div>
          )
      )}
      <div className="padding-top-large" />
      {(isValidArray(props.data?.assets?.images) ||
        typeof props.data?.assets?.audio === "string") && (
        <div className="inherit-parent-width">
          <CarouselAndAudioPlayer
            assetsLoading={props.complaintsLoading.assets}
            fileSrc={props.data?.assets}
            onImageClick={(data) => {
              if (typeof props.setPreview === "function") {
                props.setPreview(data);
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

// const ComplaintDetails = (props) => {
//   return (
//     <div className="inherit-parent-width">
//       {getSelectedComplaintsDetailsData(props.data)?.map(
//         (data, i) =>
//           isValidArray(data) && (
//             <div key={i}>
//               <Fields title={data?.[0]} data={data?.[1]} />
//             </div>
//           )
//       )}
//     </div>
//   );
// };

const ComplaintManage = (props) => {
  const isTakenOverByMe = useMemo(() => {
    if (!isValidObject(props.data?.takenOverBy)) {
      return false;
    }

    if (props.data?.takenOverBy?.employeeId === undefined) {
      return false;
    }

    return (
      props.data?.takenOverBy?.employeeId === props.profile?.data?.employeeId
    );
    // eslint-disable-next-line
  }, [props.data?.takenOverBy?.employeeId, props.profile?.data?.employeeId]);

  return (
    <div className="inherit-parent-width">
      {isTakenOverByMe && props.data?.status?.currentStatus === "OPEN" && (
        <div className="inherit-parent-width">
          <CarouselAndAudioPlayer
            assetsLoading={props.complaintsLoading.assets}
            setCroppedImage={props.setCroppedImage}
            fileSrc={props.croppedImage}
            dataCy="update-section"
            setFile={props.setFile}
            file={props.file}
            add={true}
            setErrorStatus={props.setErrorStatus}
            onImageClick={(data) => {
              if (typeof props.setPreviewImage === "function") {
                props.setPreviewImage(data);
              }
            }}
          />

          <div className=" padding-top-larger">
            <InputBox
              name="remarks"
              // type="password"
              label="Remarks"
              value={props.remarks}
              onChange={(event) => {
                props.setRemarks(event.target.value);
              }}
              labelFontColor="font-color-tertiaryColor"
              fontColor="font-color-tertiaryColor"
              removeResponsive={true}
              data-cy="remarks-input"
            />
          </div>
        </div>
      )}

      {!isTakenOverByMe && props.data?.status?.currentStatus === "OPEN" && (
        <Button
          type="button"
          text="TAKEOVER"
          boxShadow={false}
          loading={props.loading}
          onClick={props.takeOverOnClick}
          className="margin-top-large"
          data-cy="TAKEOVER-CONFIRM-BUTTON"
        />
      )}

      {props.data?.status?.currentStatus === "UNDER REVIEW" && (
        <>
          <div className="text-align-center font-size-small padding-top-large font-color-tertiaryColor6">
            YOU CAN EITHER CLOSE THE COMPLAINT OR REOPEN IF THE MEDIA IS
            INCORRECT
          </div>
          <div className="display-flex flex-direction-column inherit-parent-width flex-justify-content-space-between margin-top-large">
            <Button
              boxShadow={false}
              type="button"
              text="Verify & Close complaint"
              onClick={() => {
                props.verifyCompliantClick("CLOSE");
              }}
              data-cy="VERIFY-CLOSE-COMPLAINT-BUTTON"
            />
            <Button
              boxShadow={false}
              type="button"
              variant="transparent"
              text="Reopen Compliant"
              className="padding-top-large"
              onClick={() => {
                props.verifyCompliantClick("OPEN");
              }}
              data-cy="VERIFY-REOPEN-COMPLAINT-BUTTON"
            />
          </div>
        </>
      )}

      {props.data?.status?.currentStatus === "OPEN" && isTakenOverByMe && (
        <Button
          type="button"
          className="margin-top-default"
          text="CLOSE COMPLAINT"
          boxShadow={false}
          loading={props.loading}
          onClick={props.closeComplaintClick}
          disabled={props.closeComplaintDisable}
          data-cy="CLOSE-COMPLAINT-BUTTON"
        />
      )}
    </div>
  );
};
